import { ActionTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { RootState } from '@/store/state';
import { merchantApiService } from '@/api';
import { MerchantState } from '@/store/modules/merchant/state';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';

const actions: ActionTree<MerchantState, RootState> = {

  async [ActionTypes.GetMerchantDetails]({ commit }, merchantId: number) {
    const merchantDetails: MerchantDetailsModel = await merchantApiService.getMerchantById(merchantId);
    return commit(ActionTypes.GetMerchantDetails, merchantDetails);
  },

};

export default actions;
